import mixins from 'vue-typed-mixins';

import UserStamp from '@/user/components/userStamp/UserStamp.vue';
import UnitSelectMixin from '@/user/mixins/UnitSelectMixin';




export default mixins(UnitSelectMixin).extend({

  name: 'UnitSelectNumber',

  components: {
    UserStamp,
  },

  async created(): Promise<void> {
    // 進度読み込み
    await this.loadProgressesState(this.courseId);
  },

});
